import { message } from 'antd';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import DictionaryTypes from '../../models/dictionary-types';
import Subjects from '../../models/subjects';
import DictionariesService from '../../services/dictionaries';

export interface SelectorItem {
    id: string;
    name: string;
}

export abstract class SelectorStore {
    @observable items: SelectorItem[] = [];
    @observable selectedItems: string[] = [];
    @observable subject: Subjects;
    @observable type: DictionaryTypes;
    @observable newItem: string = "";
    @observable multiple: boolean;
    dictionariesService: DictionariesService; // обычно сервисы не делают observable, но если нужно – ок

    constructor(subject: Subjects, type: DictionaryTypes, multiple?: boolean) {
        this.subject = subject;
        this.type = type;
        this.multiple = multiple === undefined ? true : multiple;
        this.dictionariesService = new DictionariesService();

        makeObservable(this); // ← без аргументов, декораторы говорят, что делать
    }

    @action
    loadDictionary = async () => {
        try {
            const data = await this.dictionariesService.getDictionary(this.subject, this.type);
            runInAction(() => {
                this.items = data;
            });
        } catch (error) {
            runInAction(() => { message.error(String(error)) });
        }
    }

    @action
    setNewItem(name: string) {
        if (name) this.newItem = name;
    }

    @action
    createItem(): void {
        if (this.newItem) {
            try {
                this.dictionariesService.createItem(this.subject, this.newItem, this.type).then(
                    response => {
                        if (response.ok) {
                            this.loadDictionary();
                            this.newItem = "";
                        } else {
                            response.json().then(error => message.error(error['detail']));
                        }
                    }
                );
            } catch (error) {
                runInAction(() => { message.error(String(error)) });
            }
        }
    }

    @action
    reset(): void {
        this.selectedItems = [];
        console.log("see" + this.selectedItems);
    }

    @action
    selectItem(value: string[]): void {
        this.selectedItems = value;
    }

    @computed
    get selectedItemAsNumber(): number | null {
        return this.selectedItems.length === 0 ? null : Number(this.selectedItems[0]);
    }

    @computed
    get selectedItemValue(): string {
        if (this.selectedItems.length === 0) return '';
        return this.items
            .filter(item => this.selectedItems.includes(item.id))
            .map(item => item.name)
            .reduce((acc, item) => acc + ', ' + item, '');
    }
}